import styled, { keyframes } from 'styled-components/macro';

import TextShadow from './animations/TextShadow';

export const MobileScreenWrapper = styled.div<{ sizeRatio: number }>`
  z-index: 4;
  cursor: pointer;
  display: none;
  position: absolute;
  left: ${({ sizeRatio }) => `calc(50% - ${265 * sizeRatio}px)`};
  top: ${({ sizeRatio }) => `${327 * sizeRatio}px`};
  width: ${({ sizeRatio }) => `${314 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${175 * sizeRatio}px`};
  background-image: linear-gradient(45deg, #00b8994d, #095d4e6e);
  border-radius: 10px;
  -webkit-box-shadow: inset -9px 17px 16px -8px #0000006a, inset 12px -17px 24px -6px #ffffff85;
  box-shadow: inset -9px 17px 16px -8px #0000006a, inset 12px -17px 24px -6px #ffffff85;

  text-align: center;
  align-items: center;
  font-size: ${({ sizeRatio }) => `${29 * sizeRatio}px`};
  font-weight: bold;
  animation: ${TextShadow} 1.6s infinite;
  font-family: 'Presicav';

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: flex;
  `};
  ${({ theme, sizeRatio }) => theme.mediaWidth.upToExtraSmall`
    left: ${`calc(50% - ${265 * sizeRatio}px)`};
    top: ${`${475 * sizeRatio}px`};
    width: ${`${314 * sizeRatio}px`};
    height: ${`${175 * sizeRatio}px`};
  `};

  // scanlines
  &::before {
    border-radius: 10px;
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(#00b89900 50%, #20e8aa30 50%), linear-gradient(90deg, #ff000004, #00ff0004, #0000ff04);
    z-index: 2;
    background-size: 100% 1px, 2px 100%;
    pointer-events: none;
  }
`;

export const BackgroundModal = styled.div`
  z-index: 9997;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000ad;
`;

export const ScreenWrapper = styled.div<{ sizeRatio: number; showMobileModal: boolean }>`
  cursor: none;

  z-index: 4;

  position: absolute;
  left: ${({ sizeRatio }) => `calc(50% - ${492 * sizeRatio}px)`};
  top: ${({ sizeRatio }) => `${103 * sizeRatio}px`};
  width: ${({ sizeRatio }) => `${556 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${317 * sizeRatio}px`};
  background-image: linear-gradient(45deg, #00b89970, #095d4e92);
  border-radius: 10px;
  -webkit-box-shadow: inset -9px 17px 16px -8px #000000bf, inset 12px -17px 24px -6px #ffffff85;
  box-shadow: inset -9px 17px 16px -8px #000000bf, inset 12px -17px 24px -6px #ffffff85;

  display: flex;
  align-items: center;
  justify-content: center;

  animation: ${TextShadow} 1.6s infinite;

  overflow: hidden;

  ${({ theme, showMobileModal }) => theme.mediaWidth.upToMedium`
    cursor: default;
    display: ${showMobileModal ? 'flex' : 'none'};
    z-index: 9998;
    width: calc(100% - 40px);
    height: 80%;
    left: 20px;
    top: 10%;
    background-image: linear-gradient(45deg, #00947b, #07483c);
    border-radius: 20px;
    -webkit-box-shadow: inset -9px 17px 16px -8px #000000bf, inset 12px -17px 24px -6px #ffffff85, 0px 0px 10px 7px #ffffff44;
    box-shadow: inset -9px 17px 16px -8px #000000bf, inset 12px -17px 24px -6px #ffffff85, 0px 0px 10px 7px #ffffff44;
  `};

  // scanlines
  &::before {
    border-radius: 10px;
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(#00b89900 50%, #20e8aa30 50%), linear-gradient(90deg, #ff000004, #00ff0004, #0000ff04);
    z-index: 2;
    background-size: 100% 2px, 3px 100%;
    pointer-events: none;
  }
`;

export const scanLineAnim = keyframes`
  0%{bottom:100%; opacity: 0; }70%{bottom:100%; opacity: 0.1; }100%{bottom:0px}
`;

export const ScanLine = styled.div`
  float: left;
  width: 100%;
  height: 50px;
  z-index: 8;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0, rgba(255, 255, 255, 0.4) 10%, rgba(0, 0, 0, 0.1) 100%);
  opacity: 0.1;
  position: absolute;
  bottom: 0;
  animation: ${scanLineAnim} 6s linear infinite;
`;

export const AccessDiskWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
`;
